import styled from 'styled-components';
import { Body1Font, Subtitle1Font, Title3Font } from '../../../../../../themes/fonts';
import { THEME } from '../../../../../../themes';
import Meter
  from '../../../../../../components/match/match-content/smart-widgets/move-meter-widget/meter/meter.component';
import { ASSETS } from '../../../../../../assets';
import IconButton from '../../../../../../components/Common/Buttons/icon-button/icon-button.component';
import { hexToRgbA } from '../../../../../../utils/colors';

export const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Body = styled.div`
  margin-top: ${THEME.SPACING.TINO};
`;

export const StyledMeter = styled(Meter)`
  margin-top: ${THEME.SPACING.TINO};
`;

export const Title = styled.div<{ color?: string }>`
  ${Subtitle1Font};
  font-weight: 700;
  color: ${({ color }) => color || THEME.COLORS.TRUE_BLACK};;
`;

export const Icon = styled(ASSETS.CRYSTAL_BALL)``;

export const InfoButton = styled(IconButton)`
  height: 16px;
  width: 16px;
  background-color: transparent;
  border-radius: ${THEME.RADIUS.CIRCLE};
  align-self: center;
`;

export const InfoIcon = styled(ASSETS.QUESTION_FILLED)`
  color: ${hexToRgbA(THEME.COLORS.PRIMARY, THEME.OPACITY.LOW)};
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINY};
  color: ${THEME.COLORS.CONTENT_A};
  width: 480px;
  padding: 0 ${THEME.SPACING.MEDIUM};
`;

export const InfoTitle = styled.div`
  ${Title3Font};
  font-weight: bold;
  line-height: 1.5;
`;

export const InfoDescription = styled.div`
  ${Body1Font};
  line-height: 1.5;
  opacity: 0.6;
`;
